module.exports = __webpack_public_path__ + "img/align-left.3b950de8.svg";